export const initialState = {
  showcases: [],
};

export default function showcases(state = initialState) {
  return state;
}
